import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';
import { Bus, useTour } from '@orion.ui/orion';
import { ref } from 'vue';

export type TourNewNavigationEmits = {};
export type TourNewNavigationProps = {};

export default class TourNewNavigationSetup extends BaseSetup {

	static readonly defaultProps = {};

	readonly _tourNewNavigation = ref<OrionTour>();

	@Reactive private readonly state = {};

	constructor (
		private props: TourNewNavigationProps,
		private emits: TourNewNavigationEmits,
	) {
		super();
	}

	protected onMounted () {
		super.onMounted();
		useTour('tourNewNavigation', this._tourNewNavigation.value);
	}

	toggleMenu (val: boolean) {
		return {
			callback: () => {
				return new Promise((resolve) => {
					Bus.emit('SharedLayoutSetup:openAsideMobileNav', val);
					setTimeout(() => {
						resolve(true);
					}, 600);
				});
			},
		};
	}

}
